const leType = window.location.href.indexOf('lendingtree.com') > -1 ? 'non-framed' : 'framed';
const leVersion = 'LE2.0';
const pageUrl = window.location.href;

export default {
    methods: {
        trackContactLenderClicked(apr, lenderName, offerId, loanAmount, contactNumber, loanPurpose = '') {
            return [
                { key: 'le_apr', value: apr },
                { key: 'le_lendername', value: lenderName },
                { key: 'le_request_id', value: offerId },
                { key: 'loan_amount_requested', value: loanAmount },
                { key: 'le_PhoneN', value: contactNumber },
                { key: 'le_loan_purpose', value: loanPurpose },
                { key: 'le_type', value: leType },
                { key: 'le_version', value: leVersion },
            ];
        },
        trackResultsInDebtRelief(lenderName, vertical) {
            return [
                { key: 'preprime_loan_amount', value: this.amount ? this.amount : '' },
                { key: 'preprime_page_url', value: window.location.href.split('?')[0] },
                { key: 'preprime_partner_name', value: lenderName || '' },
                { key: 'preprime_partner_type', value: vertical || '' },
                { key: 'preprime_state', value: this.state ? this.state : '' },
            ];
        },
        trackVisitLenderDebtRelief() {
            return [
                { key: 'preprime_destinationURL', value: this.newtargetUrl ? this.newtargetUrl : '' },
                { key: 'preprime_formId', value: this.formId ? this.formId : '' },
                { key: 'preprime_loan_amount', value: this.loanAmount ? this.loanAmount : '' },
                { key: 'preprime_page_url', value: window.location.href },
                { key: 'preprime_partner_name', value: this.lenderName ? this.lenderName : '' },
                { key: 'preprime_partner_type', value: this.partnerType ? this.partnerType : '' },
                { key: 'preprime_sid', value: this.SessionId ? this.SessionId : '' },
                { key: 'preprime_state', value: this.state ? this.state : '' },
            ];
        },
        trackLenderViewSiteDebtRelief() {
            return [
                { key: 'order_id', value: this.SessionId ? this.SessionId : '' },
                {
                    key: 'products',
                    value:
                    {
                        name: this.partnerType ? this.partnerType : '',
                        quantity: 1,
                    },
                },
            ];
        },
        trackInputsInDebtRelief() {
            return [
                { key: 'preprime_loan_amount', value: this.Amount ? this.Amount : '' },
                { key: 'preprime_page_url', value: window.location.href },
                { key: 'preprime_partner_type', value: this.PreprimePartnerType ? this.PreprimePartnerType : '' },
                { key: 'preprime_sid', value: this.SessionId ? this.SessionId : '' },
                { key: 'preprime_state', value: this.State ? this.State : '' },
            ];
        },
        // Credit Repair
        trackCreditRepairPartners(response) {
            return [
                { key: 'preprime_page_url', value: pageUrl.split('?')[0] },
                { key: 'preprime_partner_name', value: response.lender.name ? response.lender.name : '' },
                { key: 'preprime_partner_type', value: response.placement.vertical ? response.placement.vertical : '' },
            ];
        },
        trackPartnerReviews() {
            return [
                { key: 'preprime_page_url', value: pageUrl },
                { key: 'preprime_partner_name', value: this.partnerName ? this.partnerName : '' },
                { key: 'preprime_partner_type', value: this.newPartnerType ? this.newPartnerType : '' },
                { key: 'preprime_partner_state', value: this.stateName ? this.stateName : '' },
            ];
        },
        trackVisitPartnerCreditRepair() {
            return [
                { key: 'preprime_destinationURL', value: this.newtargetUrl ? this.newtargetUrl : '' },
                { key: 'preprime_formId', value: this.formId ? this.formId : '' },
                { key: 'preprime_page_url', value: pageUrl.split('?')[0] },
                { key: 'preprime_partner_name', value: this.lenderName ? this.lenderName : '' },
                { key: 'preprime_partner_type', value: this.partnerType ? this.partnerType : '' },
                { key: 'preprime_sid', value: this.SessionId ? this.SessionId : '' },
                { key: 'preprime_state', value: this.state ? this.state : '' },
            ];
        },
        trackCreditRepairPartnerCheckout() {
            return [
                { key: 'order_id', value: this.SessionId ? this.SessionId : '' },
                {
                    key: 'products',
                    value:
                    {
                        name: this.preprimePartnerType ? this.preprimePartnerType : '',
                        quantity: 1,
                    },
                },
            ];
        },
        // Insurance
        trackInsurerClick() {
            const { formData } = this;
            return [{ key: 'insurance_state', value: formData.State ? formData.State : '' },
                { key: 'zip_code', value: formData.ZipCode ? formData.ZipCode : '' },
                { key: 'insurance_type', value: formData.ProductType },
                { key: 'insurance_clickid', value: this.SessionId ? this.SessionId : '' },
                { key: 'ins_page_converted_from', value: pageUrl },
                { key: 'product', value: 'insurance' },
                {
                    key: 'otherVertical',
                    value: formData.OtherVertical === 'home insurance'
                        ? 'home'
                        : formData.OtherVertical === 'auto insurance'
                            ? 'auto'
                            : formData.OtherVertical === 'life insurance'
                                ? 'life'
                                : '',
                },
            ];
        },
        trackInsurerCheckout() {
            return [
                { key: 'order_id', value: this.SessionId ? this.SessionId : '' },
                {
                    key: 'products',
                    value:
                    {
                        name: this.InsuranceType === 'home insurance' ? 'Insurance Home' : '',
                        quantity: 1,
                    },
                },
            ];
        },
        partnerCTACheckout(formID, propertyName) {
            return [
                { key: 'order_id', value: formID },
                { key: 'Product_property_name', value: propertyName },
            ];
        },
        trackVehicleDetails(make, model) {
            return [
                { key: 'OEM-Year', value: this.ActiveYear || '' },
                { key: 'OEM-Make', value: make || '' },
                { key: 'OEM-Model', value: model || '' },
            ];
        },
        // Audience Tracking
        trackAudiencePartnerDetails(trackObj) {
            return [
                { key: 'partner_name', value: trackObj.name ? trackObj.name : '' },
                { key: 'product_name', value: trackObj.productName ? trackObj.productName : '' },
                { key: 'partner_rank', value: trackObj.rank ? trackObj.rank : '' },
                { key: 'partner_state', value: trackObj.stateName ? trackObj.stateName : '' },
            ];
        },
        trackAudiencePartnersView(trackObj) {
            return this.trackAudiencePartnerDetails(trackObj).concat([{ key: 'page_url', value: pageUrl.split('?')[0] }]);
        },
        trackAudiencePartnerPhoneClick(trackObj) {
            return this.trackAudiencePartnerDetails(trackObj).concat([{ key: 'partner_phone', value: trackObj.phoneNumber ? trackObj.phoneNumber : '' }]);
        },
        trackAudiencePartnerReview(trackObj) {
            return this.trackAudiencePartnerDetails(trackObj).concat([{ key: 'partner_review_count', value: trackObj.totalReviews ? trackObj.totalReviews : '' }]);
        },
        trackRateTableViewed(trackObj) {
            return [
                { key: 'resultCount', value: trackObj.resultCount || '' },
                { key: 'loanTerm', value: trackObj.loanTerm || '' },
                { key: 'fieldEdited', value: trackObj.fieldEdited || '' },
                { key: 'productType', value: trackObj.productType || '' },
                { key: 'sortBy', value: trackObj.sortBy || '' },
            ];
        },
        trackRateTableClicked(trackObj) {
            return [
                { key: 'lenderName', value: trackObj.lenderName || '' },
                { key: 'position', value: trackObj.position || '' },
                { key: 'loanTerm', value: trackObj.loanTerm || '' },
                { key: 'fieldEdited', value: trackObj.fieldEdited || '' },
                { key: 'productType', value: trackObj.productType || '' },
                { key: 'sortBy', value: trackObj.sortBy || '' },
            ];
        },
    },
};
